export default "__VITE_ASSET__792ee7aa__"